<template>
    <div class="mask" v-if="showFlag" >
       <div class="todo border flex-col"  >
           <div class="flex  flex-space-between padding-m" style="height: 30px;">
               <div class="font-bold">待办</div>
               <div class="font-s pointer flex flex-center-cz">
                   <div class="flex margin-right-xl flex-center-cz">
                      <span>已完成不显示</span>
                      <my-switch style="margin-top: -5px;margin-left: 5px;"  v-model="filter.notShowFinish" @change="kgChange"></my-switch>
                   </div>
                   <img class="icon1 margin-right-xl" src="@/assets/images/add.png"  @click="add"/>
                   <img class="icon" src="@/assets/images/guanbi.png" @click="close"/>
               </div>
           </div>
          <vue-custom-scrollbar class="padding-l ">
            <table class="full-width">
                <tr class="font-bold">
                    <td width="40px">#</td>
                    <td width="">事项</td>
                    <td width="120px">标签</td>
                    <td width="120px" align="center">时间</td>
                    <td width="100px">状态</td>
                    <td width="120px"></td>
                </tr>
                <tr v-for="item,index in tableData" :key="index">
                    <td>{{index+1}}</td>
                    <td><input placeholder="请输入待办事项名称" v-model="item.content" class="ui-input full-width font-m"  @blur="contentBlur(item)"/></td>
                    <td><input placeholder="用于分类" v-model="item.tag" class="ui-input w120"  @blur="tagBlur(item)"/></td>
                    <td align="center">{{item.createTime}}</td>
                    <td>{{getStatus(item.status)}}</td>
                    <td>                   
                        <img v-if="item.status != 1" class="icon1 pointer margin-right-m" src="@/assets/images/start.png" @click="start(item)"/>
                        <img v-if="item.status == 1" class="icon1 pointer margin-right-m" src="@/assets/images/stop.png" @click="stop(item)"/>
                        <img v-if="item.status != 3" class="icon pointer  margin-right-m" src="@/assets/images/finish.png" @click="finish(item)"/>
                        <img v-if="item.status != 1" class="icon pointer  margin-right-m" src="@/assets/images/delete1.png" @click="del(item)"/>
                    </td>
                </tr>

             </table>
           </vue-custom-scrollbar>
 
           <div class="msg-info-sjx"></div>
       </div>
    </div>
 
 
 </template>
 
 
 <script>
 
 import MySwitch from '@/components/switch/Switch.vue'
 import {addTodo,editTodo,deleteTodo,listTodo} from '@/api/api.js';

 import {getDateStr, getNowDate, getJsDate} from "@/utils/dateUtils.js"
 

 export default {
     name: 'Todo',
     props: {
         show: {default: false},
     },
     components:{MySwitch},
     created() {
     },
 
     watch: {
       show(val) {
           this.showFlag = val
           if (val == true) {
             console.log("load");
             this.load();
           } 
       },
     },
     data() {
         return {
             filter:{notShowFinish: true},
             showFlag: false,
             tableData:[]
 
         }
     },
 
     methods: {
        kgChange(value) {
            this.load();

        },
        getStatus(value) {
            let result = "";
            if (value == "0") {
                result = "未开始"
            } else if (value == "1") {
                result = "进行中"
            } else if (value == "2") {
                result = "已停止"
            }  else if (value == "3") {
                result = "已完成"
            }
            return result
        },
        start(item) {
            item.status = 1;
            let param = {
                id : item.id,
                status: item.status
            }
            editTodo(param).then((res) => {
                if (res.data.success == false) {
                    this.$showToast({msg: res.data.message });       
                }
            });
            
        },
        stop(item) {
            item.status = 2;
            let param = {
                id : item.id,
                status: item.status
            }
            editTodo(param).then((res) => {
                if (res.data.success == false) {
                    this.$showToast({msg: res.data.message });       
                }
            });
        },
        finish(item) {
            item.status = 3;
            let param = {
                id : item.id,
                status: item.status
            }
            editTodo(param).then((res) => {
                if (res.data.success == false) {
                    this.$showToast({msg: res.data.message });       
                } else {
                    this.load();
                }
            });
        },
        del(item) {
            this.$showMsgBox({
                caption:"询问",
                msg: '确定要删除吗？',
                callback:(data) => {
                    if (data == "yes") {
                        this.tableData = this.tableData.filter(d=>d.id != item.id);
                        this.$showLoading();
                        deleteTodo(item.id).then((res) => {
                            this.$closeLoading();
                        })
                    } 
                }
            })

        },
        load() {

            listTodo(this.filter).then((res) => {
                console.log(res);
                if (res.data.success == true) {
                    let data = res.data.result.records;
                    data.forEach(item => {
                        item.createTime = getJsDate(item.createTime)                       
                    });
                    this.tableData = data;
                }
             });
         },
         add() {
            addTodo({}).then((res) => {
                console.log(res.data);
                if (res.data.success == true) {
                    console.log(res.data);
                    let result = res.data.result;
                    result.createTime = getJsDate(result.createTime);
                    this.tableData.push(result)
                } else {
                    this.$showToast({msg: res.data.message });       
                }
            });
         },
         contentBlur(item) {
            let param = {
                id : item.id,
                content: item.content
            }
            editTodo(param).then((res) => {
                if (res.data.success == false) {
                    this.$showToast({msg: res.data.message });       
                }
            });

         },
         tagBlur(item) {
            let param = {
                id : item.id,
                tag: item.tag
            }
            editTodo(param).then((res) => {
                if (res.data.success == false) {
                    this.$showToast({msg: res.data.message });       
                }
            });
         },
         close() {
           this.$emit("close")
         }
 
     }
 }
 </script>
 
 
 <style scoped>
   .todo {
     position: absolute;
     background-color: #fff;
     border-radius: 10px;
     top:50px;
     right: 60px;
     bottom: 40px;
     width: 900px;
     z-index: 999;
     display: flex;
     flex-direction: column;
     padding: 10px;
   }
   .msg-info-sjx {
     transform: rotate(45deg);
     top: -7px;
     right: 125px;
     width: 10px;
     height: 10px;
     position: absolute;
     border-left: 1px solid rgba(0, 0, 0, .2);
     border-top: 1px solid rgba(0, 0, 0, .2);
     z-index: 9999;
     background-color: #fff;
   }
 

   .body {
    height: 510px;
   }
   .icon1 {
     width: 20px;
     height: 20px;
   }
 
   .icon {
     width: 22px;
     height: 22px;
   }
 
 
 </style>
 


// WEBPACK FOOTER //
// src/modules/todo/Todo.vue